export enum AppEnvironment {
    Local,
    AtLocal,
    HuMaster,
    HuStaging,
    HuProduction,
    AWSProduction,
    HuProductionB2B,
    AtMaster,
    AtStaging,
    AtProduction,
    ProviderTest,
    Intranet,
    AtIntranet,
    MobilDevStaging,
}
